import React, { useState, useEffect, useMemo } from "react";
import toastr from "toastr";

//Redux
import { useSelector } from "react-redux";

import "./ProfilePicture.scss";

//i18n
import { withTranslation } from "react-i18next";
import { getAvailability } from "../../Libs/CustomMethods/customMethods";

const ProfilePicture = ({
  name,
  sizePx,
  src,
  isProfile,
  isAvail,
  customStyle,
  statusProps,
  onClick,
  t,
}) => {
  const signalRConnection = useSelector((state) => state.SignalR.connSignalR);
  const { data } = useSelector((state) => state.Login);
  const {
    loadingUpdateAvailability,
    successUpdateAvailabilitySignalr,
  } = useSelector((state) => state.Availability);

  const activeAvailabilityId = useSelector(
    (state) => state.Availability.activeAvailability
  );

  const status = useMemo(() => {
    if (activeAvailabilityId) {
      const activeAvailability = getAvailability(
        data?.availabilities,
        activeAvailabilityId
      );

      if (activeAvailability) {
        return activeAvailability.typeInfo;
      }
    }
    return null;
  }, [data?.availabilities, activeAvailabilityId]);

  const [checkPermission, setCheckPermission] = useState("");

  useEffect(() => {
    if (successUpdateAvailabilitySignalr) {
      showToast("success", t("Your status has been updated"));
    }
  }, [successUpdateAvailabilitySignalr, t]);

  useEffect(() => {
    if (data?.permissions) {
      setCheckPermission(
        data.permissions["update_agent_status"] ? true : false
      );
    }
  }, []);

  const hasWhiteSpace = (s) => {
    if (s) {
      return s.indexOf(" ");
    }
  };

  const getInitialsChars = (name) => {
    if (name) {
      if (hasWhiteSpace(name) > 0) {
        //If name and surname take first character of each
        let firstName = name.substring(0, hasWhiteSpace(name));
        let lastName = name.substring(hasWhiteSpace(name) + 1);
        return {
          nameFisrtChar: firstName.charAt(0).toUpperCase(),
          surnameFirstChar: lastName.charAt(0).toUpperCase(),
        };
      } else {
        //If just name take first and second characteres
        return {
          nameFisrtChar: name.charAt(0).toUpperCase(),
          surnameFirstChar: name.charAt(1).toUpperCase(),
        };
      }
    }
  };

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
    toastr[type](message);
  };

  return (
    <React.Fragment>
      <div
        style={{
          width: sizePx ? sizePx : 36,
          height: sizePx ? sizePx : 36,
          fontSize: sizePx ? sizePx : 36,
          display: "inline-block",
        }}
      >
        {signalRConnection?.connection && isProfile && (
          <div
            className={signalRConnection?.className}
            role="status"
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: sizePx > 36 ? 3 : 0,
              position: "absolute",
              zIndex: -1,
              top: 8,
              left: 5,
              borderWidth: 10,
              width: 46,
              height: 46,
              borderRadius: 50,
            }}
          />
        )}
        {isProfile &&
          isAvail &&
          data?.availabilities?.map((avail, key) => (
            <i
              className={`bx ${
                (status === "Online" && "bxs-check-circle text-success") ||
                (status === "Volto logo" && "bxs-time-five text-warning") ||
                (status === "Ausente" && "bxs-minus-circle text-danger")
              }  font-size-15 position-absolute  ${
                loadingUpdateAvailability ? "bx-burst" : ""
              }`}
              style={{
                display: avail?.default === "1" ? "flex" : "none",
                left: "39px",
                top: "42px",
                textShadow: "2px 2px black",
              }}
              key={key}
            />
          ))}
        {statusProps && (
          <i
            className={`${checkPermission ? "change-status" : ""} d-flex bx ${
              (statusProps === "online" && "bxs-check-circle text-success") ||
              (statusProps === "backsoon" && "bxs-time-five text-warning") ||
              ((statusProps === "offline" || statusProps === "away") &&
                "bxs-minus-circle text-danger")
            }  font-size-15 position-absolute`}
            style={{
              left: sizePx ? sizePx + 10 : 46,
              top: sizePx ? sizePx + 6 : 42,
              textShadow: "2px 2px black",
            }}
            onClick={checkPermission ? onClick : null}
          />
        )}

        {src &&
        (src.match(/\.(jpeg|jpg|gif|png)$/) || src.match(/(blob)/)) != null ? (
          <img
            className={`d-flex justify-content-center rounded-circle align-items-center w-100 h-100 header-profile-user ${customStyle}`}
            style={{
              padding: sizePx > 36 ? 3 : 0,
            }}
            src={src}
            alt="Header Avatar"
          />
        ) : (
          <span
            className={`d-flex rounded-circle justify-content-center align-items-center w-100 h-100 header-profile-user ${customStyle}`}
            style={{
              backgroundColor: "#3452E1",
              color: "white",
              fontSize: "0.4em",
              zIndex: 1,
            }}
          >
            {name
              ? getInitialsChars(name).nameFisrtChar +
                "" +
                getInitialsChars(name).surnameFirstChar
              : null}
          </span>
        )}
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ProfilePicture);
